import { render, staticRenderFns } from "./search-item.vue?vue&type=template&id=411979c2&"
import script from "./search-item.vue?vue&type=script&lang=js&"
export * from "./search-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports